<div class="chart-container"
     [ngClass]="{
          'chart-container-bar': isChartBar(),
          'chart-container-gauge': isChartGauge(),
          'chart-container-line': isChartLine(),
          'chart-container-edit-mode':isInEditMode()
        }">
  @if (!showChart()) {
    <div
      class="d-flex align-items-center justify-content-center w-100 h-100 mb-0 alert alert-info text-center">
      <em class="fa-solid fa-circle-info mr-2"></em>
      <span translate>No Data available. Please check the chart configuration.</span>
    </div>
  }

  @if (showChart()) {
    <highcharts-chart
      [oneToOne]="oneToOneFlag()"
      [constructorType]="chartConstructor"
      [options]="chartOptions()"
      [(update)]="updateFlag"
      (chartInstance)="onChartInstance($event)"
      class="highcharts-chart">
    </highcharts-chart>
  }
</div>
